export default "__VITE_ASSET__DJcAO9WZ__"